import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import './Form.scss';
import { Button } from '../index';

class Form extends React.Component {
  static propTypes = {
    /** custom classname to add to the component. */
    className: PropTypes.string,
    /** a function to call when submit button is clicked. */
    onSubmit: PropTypes.func,
    /** a function to call when validation fails. */
    onValidationFail: PropTypes.func,
    /** validator function. */
    validator: PropTypes.func,
    /** whether the form is submitting or not. */
    submitting: PropTypes.bool,
  };

  static defaultProps = {
    className: '',
    onSubmit: () => {},
    onValidationFail: () => {},
    validator: () => true,
    submitting: false,
  };

  handleSubmit = e => {
    const { onSubmit, validator, onValidationFail } = this.props;
    e.preventDefault();

    if (!validator()) {
      onValidationFail();
      return;
    }

    onSubmit();
  };

  render() {
    const { className, children, submitting } = this.props;

    return (
      <form className={classnames('common-form', className)}>
        {children}
        <Button
          block
          square
          background="secondary"
          onClick={this.handleSubmit}
          loading={submitting}
        >
          제출하기
        </Button>
      </form>
    );
  }
}

export default Form;



// WEBPACK FOOTER //
// ./src/components/common/form/Form.js